module.exports = __webpack_public_path__ + "img/1185f.6a517492.png";